import { render, staticRenderFns } from "./PollResultsTableColumn.vue?vue&type=template&id=fa5de6b2&scoped=true"
import script from "./PollResultsTableColumn.vue?vue&type=script&lang=js"
export * from "./PollResultsTableColumn.vue?vue&type=script&lang=js"
import style0 from "./PollResultsTableColumn.vue?vue&type=style&index=0&id=fa5de6b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5de6b2",
  null
  
)

export default component.exports